var SDK_VERSION = '7.6.0';
export { SDK_VERSION };